import { Dictionary } from 'src/app/core/model/dictionary';

export class AccumulatorEdit
{
    public id = null;
    public version = null;
    public name = '';
    public description = '';
    public enabled = true;
    public maxUnits: number = null;
    public maxAmount: number = null;
    public frequency: Dictionary = null;
    public duration: number = null;
    public validateMaximum = false;
    public allowNonConsecutive = false;
    public startDate: Date;
}
